import { Image, handleEnterKey } from '@iheartjane/reefer';

import styles from './carouselItem.module.css';

type CarouselItemProps = {
  activeIndex: number;
  fallbackSrc?: string;
  imageAlt: string;
  imageSrc: string;
  index?: number;
  onClick: () => void;
  srcSet?: string;
  url?: string | null;
};

export const CarouselItem = ({
  activeIndex,
  fallbackSrc,
  imageAlt,
  imageSrc,
  index = 0,
  onClick,
  srcSet,
  url,
}: CarouselItemProps) => {
  const imageObjectFit = 'cover';
  const imageBorderRadius = 'none';
  const isActive = activeIndex === index;
  const isPriority = isActive || Math.abs(activeIndex - index) <= 1;

  const image = (
    <Image
      src={imageSrc}
      srcSet={srcSet}
      altText={imageAlt}
      objectFit={imageObjectFit}
      height="100%"
      borderRadius={imageBorderRadius}
      fallbackSrc={fallbackSrc}
      loading={isPriority ? 'eager' : 'lazy'}
      className={url ? undefined : styles['innerCarouselImg']}
    />
  );

  // link slides activate via the anchor to avoid nesting interactive elements
  if (url) {
    return (
      <div
        className={styles['innerCarouselItem']}
        data-testid="carousel-item"
        draggable={false}
      >
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles['innerCarouselImg']}
          onClick={onClick}
        >
          {image}
        </a>
      </div>
    );
  }

  return (
    <div
      className={styles['innerCarouselItem']}
      data-testid="carousel-item"
      draggable={false}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyUp={(event) => handleEnterKey(event, onClick)}
    >
      {image}
    </div>
  );
};
